import { Clear, Search } from '@mui/icons-material';
import { Box, IconButton, InputAdornment } from '@mui/material';
import React from 'react';
import { StyledTextField } from '../styles/styles';

interface FAQViewSearchFieldProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  onClearSearch: () => void;
}

export function FAQViewSearchField({
  searchTerm,
  onSearchTermChange,
  onClearSearch,
}: FAQViewSearchFieldProps) {
  return (
    <Box sx={{ mb: 4, mt: '2.0rem' }}>
      <StyledTextField
        fullWidth
        variant="outlined"
        placeholder="Search FAQs..."
        value={searchTerm}
        onChange={(event) => onSearchTermChange(event.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <IconButton
                  onClick={onClearSearch}
                  size="small"
                  sx={{
                    color: 'text.secondary',
                    '&:hover': { color: 'text.primary' },
                  }}
                >
                  <Clear />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            borderRadius: 2,
          },
        }}
      />
    </Box>
  );
}
